export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';